import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'

const tagStyles = {
  secondary: {
    textColor: 'text-purple-800',
    bgColor: 'bg-purple-400',
    borderColor: 'border-purple-500'
  },
  success: {
    textColor: 'text-green-800',
    bgColor: 'bg-green-500',
    borderColor: 'border-green-700'
  },
  neutral: {
    textColor: 'text-neutral-600',
    bgColor: 'bg-neutral-200',
    borderColor: 'border-neutral-500'
  },
  primary: {
    textColor: 'text-blue-700',
    bgColor: 'bg-blue-400',
    borderColor: 'border-blue-600'
  },
  info: {
    textColor: 'text-yellow-800',
    bgColor: 'bg-yellow-300',
    borderColor: 'border-yellow-700'
  },
  warning: {
    textColor: 'text-orange-800',
    bgColor: 'bg-orange-400',
    borderColor: 'border-orange-700'
  },
  default: {
    textColor: 'text-blue-700',
    bgColor: 'bg-blue-400',
    borderColor: 'border-blue-600'
  }
}

export const TagBox = ({ className, label, tagType }) => {
  const { textColor, bgColor, borderColor } = tagStyles[tagType] || tagStyles.default

  return (
    <span
      className={clsx(
        textColor,
        bgColor,
        borderColor,
        'text-sm font-bold px-2 py-1 border border-solid rounded-sm inline',
        className
      )}
    >
      {label}
    </span>
  )
}

TagBox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  tagType: PropTypes.string
}
